import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle
} from '@/components/ui/drawer';
import { useAvailabilities } from '@/data/availability';
import { useCoach } from '@/data/coach';
import { useCoachActivity } from '@/data/coachActivity';
import { getLocalDateFromDate } from '@/helpers/dateHelpers';
import { CalendarSearch } from 'lucide-react';
import {
  Empty,
  EmptyIcon,
  EmptyTitle,
  EmptyDescription
} from '@/components/ui/empty';
import { ScrollArea } from '@/components/ui/scroll-area';
import SelectAvailability from './components/selectAvailabilityDrawer/SelectAvailability';
import { useAvailabilityContext } from './useAvailabilityContext';
import { useEffect } from 'react';

const SelectAvailabilityDrawer = () => {
  const {
    closeAvailability,
    isAvailabilityOpen,
    selectedDate,
    selectedCoachId,
    selectedActivityId,
    selectedCoachActivityId
  } = useAvailabilityContext();
  const availabilities = useAvailabilities(
    selectedCoachId,
    selectedActivityId,
    selectedDate
  );
  const coachActivity = useCoachActivity(selectedCoachActivityId);
  const coach = useCoach(selectedCoachId);

  useEffect(() => {
    if (isAvailabilityOpen) {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    }

    return () => {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    };
  }, [isAvailabilityOpen]);

  if (availabilities.isLoading && !availabilities.data) {
    return null;
  }
  if (!availabilities.data) {
    return null;
  }

  if (coachActivity.isLoading || !coachActivity.data) {
    return null;
  }

  if (!selectedDate || availabilities.data.length === 0) {
    return (
      <Drawer
        className="overflow-hidden"
        open={isAvailabilityOpen}
        onOpenChange={(value) => closeAvailability(value)}
      >
        <DrawerContent>
          <DrawerHeader className="text-left">
            <DrawerTitle>
              {coach.data.user.firstname} {coach.data.user.lastname}{' '}
              Availability
            </DrawerTitle>
            <DrawerDescription>
              {selectedDate && getLocalDateFromDate(selectedDate)}
            </DrawerDescription>
          </DrawerHeader>
          <Empty className="mb-14">
            <EmptyIcon>
              <CalendarSearch />
            </EmptyIcon>
            <EmptyTitle>No Availability Found</EmptyTitle>
            <EmptyDescription>Try selecting a different date</EmptyDescription>
          </Empty>
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <Drawer
      className="overflow-hidden"
      open={isAvailabilityOpen}
      onOpenChange={(value) => closeAvailability(value)}
    >
      <DrawerContent>
        <DrawerHeader className="text-left">
          <DrawerTitle>
            {coach.data.user.firstname} {coach.data.user.lastname} Availability
          </DrawerTitle>
          <DrawerDescription>
            {selectedDate && getLocalDateFromDate(selectedDate)}
          </DrawerDescription>
        </DrawerHeader>
        <ScrollArea className="h-[calc(75vh-8rem)] px-2">
          <div className="space-y-4 pb-4">
            {availabilities.data.map((availability) => (
              <SelectAvailability
                key={availability.id}
                availability={availability}
                coachActivity={coachActivity.data}
              />
            ))}
          </div>
        </ScrollArea>
      </DrawerContent>
    </Drawer>
  );
};

export default SelectAvailabilityDrawer;
